export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const DAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export const COLORS = [
  { bg: 'bg-red-500', gradient: 'bg-red-500', name: 'Red' },
  { bg: 'bg-orange-500', gradient: 'bg-orange-500', name: 'Orange' },
  { bg: 'bg-amber-500', gradient: 'bg-amber-500', name: 'Amber' },
  { bg: 'bg-yellow-500', gradient: 'bg-yellow-500', name: 'Yellow' },
  { bg: 'bg-lime-500', gradient: 'bg-lime-500', name: 'Lime' },
  { bg: 'bg-green-500', gradient: 'bg-green-500', name: 'Green' },
  { bg: 'bg-emerald-500', gradient: 'bg-emerald-500', name: 'Emerald' },
  { bg: 'bg-teal-500', gradient: 'bg-teal-500', name: 'Teal' },
  { bg: 'bg-cyan-500', gradient: 'bg-cyan-500', name: 'Cyan' },
  { bg: 'bg-sky-500', gradient: 'bg-sky-500', name: 'Sky' },
  { bg: 'bg-blue-500', gradient: 'bg-blue-500', name: 'Blue' },
  { bg: 'bg-indigo-500', gradient: 'bg-indigo-500', name: 'Indigo' },
  { bg: 'bg-violet-500', gradient: 'bg-violet-500', name: 'Violet' },
  { bg: 'bg-purple-500', gradient: 'bg-purple-500', name: 'Purple' },
  { bg: 'bg-fuchsia-500', gradient: 'bg-fuchsia-500', name: 'Fuchsia' },
  { bg: 'bg-pink-500', gradient: 'bg-pink-500', name: 'Pink' },
  { bg: 'bg-rose-500', gradient: 'bg-rose-500', name: 'Rose' },
  { bg: 'bg-slate-500', gradient: 'bg-slate-500', name: 'Slate' },
];

// Tailwind bg class → RGBA at ~15% opacity for cell background tinting
export const TAILWIND_COLOR_RGBA: Record<string, string> = {
  'bg-red-500': 'rgba(239, 68, 68, 0.15)',
  'bg-orange-500': 'rgba(249, 115, 22, 0.15)',
  'bg-amber-500': 'rgba(245, 158, 11, 0.15)',
  'bg-yellow-500': 'rgba(234, 179, 8, 0.15)',
  'bg-lime-500': 'rgba(132, 204, 22, 0.15)',
  'bg-green-500': 'rgba(34, 197, 94, 0.15)',
  'bg-emerald-500': 'rgba(16, 185, 129, 0.15)',
  'bg-teal-500': 'rgba(20, 184, 166, 0.15)',
  'bg-cyan-500': 'rgba(6, 182, 212, 0.15)',
  'bg-sky-500': 'rgba(14, 165, 233, 0.15)',
  'bg-blue-500': 'rgba(59, 130, 246, 0.15)',
  'bg-indigo-500': 'rgba(99, 102, 241, 0.15)',
  'bg-violet-500': 'rgba(139, 92, 246, 0.15)',
  'bg-purple-500': 'rgba(168, 85, 247, 0.15)',
  'bg-fuchsia-500': 'rgba(217, 70, 239, 0.15)',
  'bg-pink-500': 'rgba(236, 72, 153, 0.15)',
  'bg-rose-500': 'rgba(244, 63, 94, 0.15)',
  'bg-slate-500': 'rgba(100, 116, 139, 0.15)',
  'bg-gray-400': 'rgba(156, 163, 175, 0.15)',
  'bg-unassigned': 'rgba(156, 163, 175, 0.15)',
};

// Tonal event card colors for week view: pastel bg + same-hue text (light/dark mode variants)
export const TONAL_COLORS: Record<string, { bgLight: string; textLight: string; bgDark: string; textDark: string; bgPrint: string }> = {
  'bg-red-500':     { bgLight: 'rgba(239,68,68,0.18)',    textLight: '#991b1b', bgDark: 'rgba(239,68,68,0.40)',    textDark: '#fca5a5', bgPrint: '#fcd4d4' },
  'bg-orange-500':  { bgLight: 'rgba(249,115,22,0.18)',   textLight: '#9a3412', bgDark: 'rgba(249,115,22,0.40)',   textDark: '#fdba74', bgPrint: '#fddcbf' },
  'bg-amber-500':   { bgLight: 'rgba(245,158,11,0.18)',   textLight: '#92400e', bgDark: 'rgba(245,158,11,0.40)',   textDark: '#fcd34d', bgPrint: '#fde8b0' },
  'bg-yellow-500':  { bgLight: 'rgba(234,179,8,0.18)',    textLight: '#854d0e', bgDark: 'rgba(234,179,8,0.40)',    textDark: '#fde047', bgPrint: '#fef3b0' },
  'bg-lime-500':    { bgLight: 'rgba(132,204,22,0.18)',   textLight: '#3f6212', bgDark: 'rgba(132,204,22,0.40)',   textDark: '#bef264', bgPrint: '#dff0a8' },
  'bg-green-500':   { bgLight: 'rgba(34,197,94,0.18)',    textLight: '#166534', bgDark: 'rgba(34,197,94,0.40)',    textDark: '#86efac', bgPrint: '#bbf0d0' },
  'bg-emerald-500': { bgLight: 'rgba(16,185,129,0.18)',   textLight: '#065f46', bgDark: 'rgba(16,185,129,0.40)',   textDark: '#6ee7b7', bgPrint: '#b0edd8' },
  'bg-teal-500':    { bgLight: 'rgba(20,184,166,0.18)',   textLight: '#115e59', bgDark: 'rgba(20,184,166,0.40)',   textDark: '#5eead4', bgPrint: '#b0ecde' },
  'bg-cyan-500':    { bgLight: 'rgba(6,182,212,0.18)',    textLight: '#155e75', bgDark: 'rgba(6,182,212,0.40)',    textDark: '#67e8f9', bgPrint: '#aee8f4' },
  'bg-sky-500':     { bgLight: 'rgba(14,165,233,0.18)',   textLight: '#075985', bgDark: 'rgba(14,165,233,0.40)',   textDark: '#7dd3fc', bgPrint: '#b0dbf8' },
  'bg-blue-500':    { bgLight: 'rgba(59,130,246,0.18)',   textLight: '#1e40af', bgDark: 'rgba(59,130,246,0.40)',   textDark: '#93c5fd', bgPrint: '#c0d5fb' },
  'bg-indigo-500':  { bgLight: 'rgba(99,102,241,0.18)',   textLight: '#3730a3', bgDark: 'rgba(99,102,241,0.40)',   textDark: '#a5b4fc', bgPrint: '#c8ccfb' },
  'bg-violet-500':  { bgLight: 'rgba(139,92,246,0.18)',   textLight: '#5b21b6', bgDark: 'rgba(139,92,246,0.40)',   textDark: '#c4b5fd', bgPrint: '#d4c5fb' },
  'bg-purple-500':  { bgLight: 'rgba(168,85,247,0.18)',   textLight: '#6b21a8', bgDark: 'rgba(168,85,247,0.40)',   textDark: '#d8b4fe', bgPrint: '#dfc5fc' },
  'bg-fuchsia-500': { bgLight: 'rgba(217,70,239,0.18)',   textLight: '#86198f', bgDark: 'rgba(217,70,239,0.40)',   textDark: '#f0abfc', bgPrint: '#f2c0fc' },
  'bg-pink-500':    { bgLight: 'rgba(236,72,153,0.18)',   textLight: '#9d174d', bgDark: 'rgba(236,72,153,0.40)',   textDark: '#f9a8d4', bgPrint: '#fbc0df' },
  'bg-rose-500':    { bgLight: 'rgba(244,63,94,0.18)',    textLight: '#9f1239', bgDark: 'rgba(244,63,94,0.40)',    textDark: '#fda4af', bgPrint: '#fcc5cc' },
  'bg-slate-500':   { bgLight: 'rgba(100,116,139,0.18)',  textLight: '#1e293b', bgDark: 'rgba(100,116,139,0.40)',  textDark: '#cbd5e1', bgPrint: '#d0d6dd' },
  'bg-unassigned':  { bgLight: 'rgba(0,0,0,0.10)',         textLight: 'rgba(0,0,0,0.65)',     bgDark: 'rgba(255,255,255,0.08)',  textDark: 'rgba(255,255,255,0.50)', bgPrint: '#e5e5e5' },
};

// ─── Custom color utilities ───────────────────────────────────────────────────

export function isHexColor(color: string): boolean {
  return /^#[0-9a-f]{6}$/i.test(color);
}

function hexToRgb(hex: string): [number, number, number] {
  return [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
  ];
}

function rgbToHsl(r: number, g: number, b: number): [number, number, number] {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  const l = (max + min) / 2;
  if (max === min) return [0, 0, l * 100];
  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h = 0;
  switch (max) {
    case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
    case g: h = ((b - r) / d + 2) / 6; break;
    case b: h = ((r - g) / d + 4) / 6; break;
  }
  return [h * 360, s * 100, l * 100];
}

function hslToHex(h: number, s: number, l: number): string {
  s /= 100; l /= 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    return Math.round(255 * (l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)))
      .toString(16).padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

type TonalEntry = { bgLight: string; textLight: string; bgDark: string; textDark: string; bgPrint: string };

export function getTonalColors(color: string): TonalEntry {
  if (TONAL_COLORS[color]) return TONAL_COLORS[color];
  if (!isHexColor(color)) return TONAL_COLORS['bg-unassigned'];
  const [r, g, b] = hexToRgb(color);
  const [h, s] = rgbToHsl(r, g, b);
  return {
    bgLight:   `rgba(${r},${g},${b},0.18)`,
    textLight: hslToHex(h, Math.min(s, 80), 28),
    bgDark:    `rgba(${r},${g},${b},0.40)`,
    textDark:  hslToHex(h, Math.min(s, 70), 78),
    bgPrint:   `rgba(${r},${g},${b},0.25)`,
  };
}

export function getRgbaColor(color: string): string {
  if (TAILWIND_COLOR_RGBA[color]) return TAILWIND_COLOR_RGBA[color];
  if (!isHexColor(color)) return 'rgba(156, 163, 175, 0.15)';
  const [r, g, b] = hexToRgb(color);
  return `rgba(${r},${g},${b},0.15)`;
}

export const CUSTOM_PALETTE_CAP = 5;

export const LONG_EVENT_THRESHOLD = 15; // Events >= 15 days center the modal
export const COLLAPSED_EVENT_ROWS = 3;
export const MAX_EVENT_ROWS = 20;
export const DRAG_THRESHOLD_PX = 5;
export const DRAG_THRESHOLD_MS = 150;
export const TOOLTIP_DELAY_MS = 500;
export const HOVER_CLEAR_DELAY_MS = 100;